import { useState, useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useReactToPrint } from 'react-to-print'
import styles from './AdHocPrint.module.css'

// ------ Services ------ //
import * as clientEventService from '../../../services/clientEventService'
import * as badgeService from '../../../services/badgeManagementService'
import * as kioskService from '../../../services/kioskService'
// components
import HoverButton from '../../../components/Miscellaneous/HoverButton'
import PrintPage from '../../../components/Badging/PrintPage'
import PrintPageFanfold from '../../../components/Badging/PrintPageFanfold'
import LoadingSpinner from "../../../components/Miscellaneous/LoadingSpinner"

const AdHocPrint = () => {

    // State
    const [stylingForm, setStylingForm] = useState();
    const [cSSValues, setCSSValues] = useState();
    const [badgeOrientations, setBadgeOrientations] = useState();
    const [badgeDimensions, setBadgeDimensions] = useState();
    const [specialCSSRules, setSpecialCSSRules] = useState();
    const [fieldOrdering, setFieldOrdering] = useState({})
    const [registrantPrintSettings, setRegistrantPrintSettings] = useState();
    const [blankForm, setBlankForm] = useState([])
    const [registrants, setRegistrants] = useState([])
    const [loaded, setLoaded] = useState(false)
    const location = useLocation()
    const navigate = useNavigate()
    const passedState = location.state
    const [clientEventInfo, setClientEventInfo] = useState({})
    const clientEventInfoRef = useRef(null);
    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            clientEventInfoRef.current = passedData
        }

    }

    useEffect(() => {
        // reflects client/event selection changes made in Header.jsx without polling
        const handleClientEventChange = (e) => {
            // Update clientevent with every render when its value has changed.
            let savedClientEvent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current && clientEventInfoRef.current.eventId !== undefined &&
                savedClientEvent && savedClientEvent.eventId !== undefined &&
                savedClientEvent.eventId !== clientEventInfoRef.current.eventId) {
                setClientEventInfo(savedClientEvent)
                clientEventInfoRef.current = savedClientEvent;
            }
        }
        window.addEventListener('clientEventChange', handleClientEventChange)
        return () => window.removeEventListener('clientEventChange', handleClientEventChange)
    }, [])

    useEffect(() => {
        setupForm()

    }, [fieldOrdering])
    const setupForm = async () => {
        if (cSSValues && stylingForm) {
            let stylingFields = stylingForm;
            let filteredResults = []
            // apply filtering, only want name, clear value
            // check if there's a cSSValues as well
            Object.keys(stylingFields).forEach(function (stylingFieldName) {
                if (cSSValues[stylingFieldName] && !stylingFieldName.toLowerCase().includes('smaller') && !stylingFieldName.toLowerCase().includes('smallest')) {
                    let tempHolder = {
                        fieldName: stylingFieldName,
                        fieldValue: '',
                    }
                    filteredResults.push(tempHolder)
                }
                stylingFields[stylingFieldName] = '';
            });
            stylingFields.clientId = clientEventInfo.clientId;
            stylingFields.eventId = clientEventInfo.eventId;
            // store clear entries
            // clear out entries
            setStylingForm(stylingFields)
            setBlankForm(filteredResults);
            let regTemp = [
                stylingForm
            ]
            setRegistrants(regTemp)
            setLoaded(true);
        }
    }

    useEffect(() => {
        if (!clientEventInfo?.clientId || !clientEventInfo?.clientName) return;

        const fetchData = async () => {
            // retrieve all elements print needs
            // set template settings
            const req = await createRequestBody();
            const templateSettings = await badgeService.getMainTemplate(req)
            if (!templateSettings) {
                setLoaded(true);
                return;
            }
            //comes through as strings
            var savedStylingForm = templateSettings?.stylingForm ? JSON.parse(templateSettings.stylingForm) : null;
            //remove scanner field b/c registrant won't have valid entry
            delete savedStylingForm['ScannerField'];
            setStylingForm(savedStylingForm)
            var savedCssValues = templateSettings?.cssValues ? JSON.parse(templateSettings.cssValues) : null;
            setCSSValues(savedCssValues)
            var savedBadgeDimensions = templateSettings?.badgeDimensions ? JSON.parse(templateSettings.badgeDimensions) : null;
            setBadgeDimensions(savedBadgeDimensions)
            var savedBadgeOrientations = templateSettings?.badgeOrientations ? JSON.parse(templateSettings.badgeOrientations) : null;
            setBadgeOrientations(savedBadgeOrientations)
            var savedSpecialCssRules = templateSettings?.specialCSSRules ? JSON.parse(templateSettings.specialCSSRules) : null;
            setSpecialCSSRules(savedSpecialCssRules)
            // set field ordering
            const data = await badgeService.getRegFieldsOrdering(req)
            const items = Array.from(data)
            setFieldOrdering(items)
            let regPrintSettings = {
                cSSValues: savedCssValues,
                specialCSSRules: savedSpecialCssRules,
                fieldOrdering: items,
                badgeDimensions: templateSettings?.badgeDimensions ? JSON.parse(templateSettings.badgeDimensions) : null,
                badgeOrientations: templateSettings?.badgeOrientations ? JSON.parse(templateSettings.badgeOrientations) : null,
            }
            setRegistrantPrintSettings(regPrintSettings)
        }
        fetchData()

    }, [clientEventInfo])

    useEffect(() => {
        // store into local object
        if (!passedState || !passedState.clientName) {
            //let localclientevent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current) {
                setClientEventInfo(clientEventInfoRef.current)
            }
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            setClientEventInfo(passedData)
            clientEventInfoRef.current = passedData;
        }

    }, [])
    // --- REST --- //
    const createRequestBody = async () => {

        let requestBody = {}

        if (clientEventInfo.clientId && clientEventInfo.eventId) {
            requestBody =
            {
                "clientId": `${clientEventInfo.clientId}`,
                "eventId": `${clientEventInfo.eventId}`
            }
        }

        return await requestBody;
    }
    
    const handleSubmit = async e => {
        e.preventDefault()

        // call back end service here to POST form data
        try {
            //badgeManagementService.saveQrCodeSetup(appended)
        } catch (err) {
           // console.log(err)
        }
    }

    const handleChange = (e, index) => {
        let temp = stylingForm;
        if (temp ) {
            //update entry
            temp[e.target.name] = e.target.value;
        }
        setStylingForm(temp)
        let tempHolder = {
            fieldName: e.target.name,
            fieldValue: e.target.value,
        }
        setBlankForm((prevState) => {
            const newState = [...prevState]
            newState[index] = tempHolder
            return newState
        });

    }
    // React-to-Print
    const componentRef = useRef()
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "Badge Styling - Print Preview",
        removeAfterPrint: true,
        onAfterPrint: () => {
            stylingForm.clientName = clientEventInfo.clientName;
            kioskService.recordAdHocPrint(stylingForm);
            // reset page
            setupForm();
        }
    })

    const handlePrintTrigger = async e => {
        e.preventDefault()
        handlePrint()
    }

    return (
        <>
            {loaded ?
        <div className="page-area">
            <h1>AdHoc Print</h1>
                    <h2>{clientEventInfo.clientName} ({clientEventInfo.eventName})</h2>
                    <h4>Note: field availability based on template setup. </h4><br />
                    <button className={styles.backButton} onClick={() => navigate(-1)}> Back </button>
            <form
                autoComplete="off"
                onSubmit={handleSubmit}
                        className={styles.container}
            >
                        <div className={styles.leftPane}>
                    {blankForm && blankForm.length > 0 ?
                        blankForm.map((blankFormField, index) => (
                            <div className={styles.inputRow}>
                                <label className={styles.leftLabel}>{blankFormField.fieldName}: </label>
                                <input
                                    type="text"
                                    autoComplete="off"
                                    value={blankFormField.fieldValue}
                                    name={blankFormField.fieldName}
                                    onChange={(e) => handleChange(e, index )}
                                    className={styles.rightInput}
                                    key={index}
                                />
                            </div>
                            
                        ))
                        :
                        <div>
                            No matching results
                        </div>
                    }
                            <div className={styles.containerSmaller}>
                                <button className={styles.rightButton} onClick={handlePrint}>
                                    Print
                                </button>
                            </div>
                        </div>
                        {badgeDimensions && fieldOrdering ?

                            <div className={styles.rightPane}>
                                <div className={styles.adHocPrintContainer}>
                                    {
                                        badgeOrientations.onePage ?
                                            <PrintPageFanfold
                                                clientEventInfo={clientEventInfo}
                                                registrants={registrants}
                                                registrantPrintSettings={registrantPrintSettings}
                                                componentRef={componentRef}
                                                printPageBreak={false}
                                            /*printLoaded={printLoaded}*/
                                            /*setPrintLoaded={setPrintLoaded}*/
                                            />
                                            :
                                            <PrintPage
                                                clientEventInfo={clientEventInfo}
                                                registrants={registrants}
                                                registrantPrintSettings={registrantPrintSettings}
                                                componentRef={componentRef}
                                                printPageBreak={false}
                                            /*printLoaded={printLoaded}*/
                                            /*setPrintLoaded={setPrintLoaded}*/
                                            />
                                    }
                                </div>

                              
                            </div>

                            : <></>}
            </form>
        </div>
        :
<LoadingSpinner />
        }
        </>
    );
}

export default AdHocPrint;